import SectionTemplate from '../../base/SectionTemplate';

import './index.scss'

export default function Template(props) {
    return <div className='SectionTileTemplate'><SectionTemplate {...props} /></div>
}
